export const loginIdSelector = (state) => state.auth.loginId;
export const uuidSelector = (state) => state.auth.uuid;
export const tokenSelector = (state) => state.auth.token;
export const selectUserId = (state) => state.auth.user;
export const isAuthenticatedSelector = (state) => state.auth.isAuthenticated;
export const areGenCondAccepted = (state) => state.auth.generalCond;
export const isAuthenticationLoading = (state) => state.auth.isLoading;
export const loginErrorsSelector = (state) => state.auth.error;
